import { NgClass } from '@angular/common';
import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-smart-label',
  standalone: true,
  imports: [NgClass],
  templateUrl: './smart-label.component.html',
  styleUrl: './smart-label.component.scss'
})

export class SmartLabelComponent implements OnInit {
  @Output() showMoreClick = new EventEmitter<{ clickedItem: any }>();

  public label: SmartLabel = {
    message: 'oferta',
    clickable: false,
    showMore: false
  };
  @Input() product: any;
  @Input() options: { clickable: boolean, showMore: boolean, showDiscount: boolean, isPDP: boolean } = { clickable: false, showMore: false, showDiscount: false, isPDP: false };
  public smart: boolean;
  public discount: number;
  public isSuperMix = false;
  constructor() {
    //EMPTY
  }

  ngOnInit(): void {
    this.discount = this.getDiscount();
    this.getLabel();
  }

  public getLabel(): void {
    let message = '';
    if (this.product?.comodin === 0 || !this.product?.comodin) {
      switch (this.product?.offer_type) {
        case 0: {
          message = this.discount > 20 ? `-${this.discount}%` : '';
          this.smart = false;
          this.options.clickable = false;
          this.options.showMore = false;
          break;
        }
        case 1: {
          if (this.options.isPDP) {
            if (this.discount > 20) {
              message = `-${this.discount}% hasta ${this.product?.restriction} ${this.product?.format === 'KG' ? 'kg' : 'pz'}`;
            }
            this.smart = false;
            this.options.clickable = false;
            this.options.showMore = false;
          }
          break;
        }
        case 2: {
          message = `${this.options.showDiscount ? 'Llevate' : ''} ${this.product?.restriction} x $${this.product?.smart_offer}`;
          this.smart = true;
          break;
        }
        case 3: {
          message = `${this.options.showDiscount ? 'Llevate' : ''}  ${this.product?.restriction} x ${this.product?.smart_offer}`;
          this.smart = true;
          break;
        }
        default: {
          message = '';
          this.smart = false;
          this.options.clickable = false;
          this.options.showMore = false;
          break;
        }
      }
      this.label = {
        message,
        clickable: this.options?.clickable,
        showMore: this.options?.showMore
      };
    } else {

      let labelMessage = '';
      if (this.product?.offer_type === 2) {
        labelMessage = `${this.product?.restriction} x $${this.product?.smart_offer}`;
      } else if (this.product?.offer_type === 3) {
        labelMessage = `${this.product?.restriction} x ${this.product?.smart_offer}`;
      }
      this.smart = true;
      this.isSuperMix = true;
      this.label = {
        message: `${this.options.showMore ? 'Súper Mix ' : ''} ${labelMessage}`,
        clickable: this.options?.clickable,
        showMore: this.options?.showMore
      };
    }
  }

  public showMore(): void {
    this.showMoreClick.emit({ clickedItem: this.product });
  }

  public getDiscount(): number {
    const discount = 100 - Math.trunc(((this.product?.offer_type === 1 ? this.product?.smart_offer : this.product?.price) * 100) / this.product?.regular_price);
    return discount;
  }
}

export interface SmartLabel {
  message: string;
  clickable: boolean;
  showMore: boolean;
}

